import { ReactNode, createContext, useContext, useEffect, useMemo } from 'react';

import { SuggestionNavigationService } from '../services/SuggestionNavigationService';
import { useContentEditorService } from './ContentEditorServiceContext';

export const SuggestionNavigationServiceContext = createContext<
  SuggestionNavigationService | undefined
>(undefined);

export function SuggestionNavigationServiceProvider({
  children,
}: {
  readonly children: ReactNode;
}) {
  const contentEditorService = useContentEditorService();
  const service = useMemo(
    () => new SuggestionNavigationService(contentEditorService),
    [contentEditorService],
  );

  useEffect(() => () => service.dispose(), [service]);

  return (
    <SuggestionNavigationServiceContext.Provider value={service}>
      {children}
    </SuggestionNavigationServiceContext.Provider>
  );
}

export function useSuggestionNavigationService(): SuggestionNavigationService {
  const context = useContext(SuggestionNavigationServiceContext);
  if (!context) {
    throw new Error(
      'useSuggestionNavigationService must be used within SuggestionNavigationServiceProvider',
    );
  }
  return context;
}
